export default "__VITE_ASSET__aeae7e16__"